import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideMaintenance = ({ width = 48, height = 48, color = '#000000' }) => {
    return (
        <svg width={width} height={height} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M3 5.95996V44.96L4 45.96H41V43.96H5V5.95996H3Z' fill={color} />
            <path d='M13.3599 32.19L7.35986 37.19L8.63986 38.73L13.9399 34.31L20.2899 40.67L21.7499 40.62L27.9999 33.59V36.96H29.9999V30.96L28.9999 29.96H22.9999V31.96H26.7699L20.9599 38.5L14.7099 32.25L13.3599 32.19Z' fill={color} />
            <path d='M17.71 6L16 6.69V12.23L16.29 12.93L21.75 18.47L22.66 18.75L27.66 17.75L40.55 30.65H42L44.75 27.89V26.48L31.8 13.56L32.8 8.62L32.53 7.71L27 2.25L26.27 2H20.73L20 3.67L26.49 10.09L24.1 12.51L17.71 6ZM28.64 10.8V9.37L23.17 4H25.86L30.73 8.8L29.73 13.73L30 14.64L42.58 27.18L41.24 28.53L28.68 16L27.77 15.73L22.77 16.73L18 11.82V9.13L23.41 14.63H24.84L28.64 10.8Z' fill={color} />
        </svg>
    );
};

IconPowertrainGuideMaintenance.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideMaintenance;
